export const suffixDivider = ' - ';
